import { Injectable, ErrorHandler } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
  constructor(
    private alertController: AlertController,
    public toastController: ToastController
  ) {}

  handleError(error: any) {
    // Optional: Log the error or send it to a server
    console.error('Error occurred:', error);

    // Call the function to show an alert with the error
    this.showError(error);
  }

  async showError(errorMessage: string) {
    const alert = await this.alertController.create({
      header: '', // No header text
      message: `${errorMessage}`,
      cssClass: 'error-alert', // Custom class for styling
      buttons: ['OK'],
    });

    await alert.present();
  }

  async showNotice(errorMessage: string) {
    const alert = await this.alertController.create({
      header: '', // No header text
      message: `${errorMessage}`,
      cssClass: 'success-alert', // Custom class for styling
      buttons: ['OK'],
    });

    await alert.present();
  }

  async presentSuccess(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000, // Toast duration in milliseconds
      position: 'bottom', // Positions the toast at the top of the screen
    });
    await toast.present();
  }
}
